<template>
  <section
    class="parachute-wrapper fadeInDown"
    ref="animateRef"
    v-if="!isDesktop"
    @click="click"
  >
    <img
      class="parachute-icon"
      :src="require(`@/assets/images/activities/fission/parachute.png`)"
      alt="logo"
    />
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import { fission_parachute_click } from '@/pages/Activity/Fission/firebase.js'

  export default {
    computed: {
      ...mapState(['isDesktop']),
    },
    mounted() {
      if (!process.client) return
      if (this.$refs && this.$refs.animateRef) {
        this.$refs.animateRef.addEventListener('animationstart', () => {
          this.$emit('animationstart')
        })
        this.$refs.animateRef.addEventListener('animationend', () => {
          this.$emit('animationend')
        })
      }
    },
    methods: {
      click() {
        this.$emit('click')
        fission_parachute_click()
      },
    },
  }
</script>

<style lang="scss">
  .parachute-wrapper {
    width: 100%;
    height: 800px;
    position: fixed;
    left: 0%;
    top: -100%;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    .parachute-icon {
      width: 800px;
      height: 800px;
      object-fit: cover;
    }
  }
</style>
<style>
  .fadeInDown {
    animation: fadeInDown 13s 1 linear;
    will-change: transform;
  }

  @keyframes fadeInDown {
    0% {
      top: -20%;
      transform: rotate(-15deg);
    }
    20% {
      transform: rotate(0deg);
    }
    40% {
      transform: rotate(15deg);
    }
    60% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(-15deg);
    }
    100% {
      top: 100%;
      transform: rotate(0deg);
    }
  }
</style>
